import React from 'react';
import './skeleton.css';

function SkeletonPanelHeader(props) {
  return (
    <div className='panel-header'>
      <div className='skeleton-content' style={{ width: props.width }}>
        <div className='skeleton'></div>
      </div>
    </div>
  );
}

function SkeletonPanelFooter(props) {
  return (
    <div className='panel-footer'>
      <div className='skeleton-content' style={{ width: props.width }}>
        <div className='skeleton'></div>
      </div>
    </div>
  );
}

function SkeletonPanelBody(props) {
  const renderRow = (index) => {
    return (
      <div className='skeleton-content' style={{ height: props.rowHeight, marginBottom: props.rowMargin }} key={index}>
        <div className='skeleton'></div>
      </div>
    );
  };

  const renderRows = () => {
    const count = props.rows || 3;
    const rows = [];
    for (let i = 0; i < count; i++) {
      rows.push(renderRow(i));
    }
    return rows;
  };

  return (
    <div className='panel-body'>
      {renderRows()}
    </div>
  );
}

const SkeletonPanel = {};
SkeletonPanel.Header = SkeletonPanelHeader;
SkeletonPanel.Footer = SkeletonPanelFooter;
SkeletonPanel.Body = SkeletonPanelBody;

export default SkeletonPanel;